import React, { useCallback } from 'react'
import { Typography, Container, Grid, Box, IconButton, makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import i18n from '../i18n/i18n'
import { pictureUrl } from '../common/pictureUrl'
import { useUpdate } from '../reducer'
import { fade } from '@material-ui/core/styles/colorManipulator'

const LIMIT = 15

const useStyles = makeStyles((theme) => ({
  panel: {
    backgroundColor: '#ffffff',
    margin: '20px auto',
    paddingTop: '20px'
  }
}))

export const Technologies = () => {
  let technologies = useSelector(({ offers }) =>
    offers
      ? offers.data
          .map(({ technologies }) => technologies)
          .filter(Boolean)
          .reduce((all, current) => all.concat(current), [])
          .map(({ id }) => offers.included.technologies[id])
          .filter(({ main }) => main)
          .sort(byPopularity)
      : []
  )

  technologies = Array.from(new Set(technologies)).slice(0, LIMIT)

  const update = useUpdate()

  const filterByTechnology = useCallback((technologyId) => () => {
    location.href = '#search'
    setTimeout(() => {
      update(['filters', 'all'], [`Technology_${technologyId}`])
    }, 500)
  })

  const classes = useStyles()

  return (
    <div className={classes.panel} id="technologies">
      <Container>
        <Box my={5}>
          <Typography variant="h1" align="center">
            {i18n.t('main.technos')}
          </Typography>
          <Grid container justifyContent="center">
            {technologies.map((technology) => (
              <Grid item xs={6} sm={3}>
                <Box mb={3}>
                  <Typography align="center" variant="h3">
                    {technology.label}
                    <br />
                    <IconButton onClick={filterByTechnology(technology.id)}>
                      <img style={{ borderRadius: '50%' }} src={pictureUrl({ record_type: 'Technology', record_id: technology.id, name: 'icon' }, 70, 70)} alt={technology.label} />
                    </IconButton>
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </div>
  )
}

export const byPopularity = (techno1, techno2) => {
  return parseInt(techno2.popularity) - parseInt(techno1.popularity)
}
